<div class="cmb-page">
  <p class="cmb-intro">
    <i class="bx bx-merge" aria-hidden="true"></i>
    Tables you push together for a party no single table seats. Bookings use a combination only when
    no single table fits, and hold every table in it.
  </p>

  @if (state === 'loading') {
    <p class="cmb-muted">Loading combinations…</p>
  } @else if (state === 'failed') {
    <p class="cmb-warn" role="alert">
      <i class="bx bx-error-circle" aria-hidden="true"></i>
      Combinations couldn't be loaded.
      <button type="button" class="cmb-link" (click)="load()">Try again</button>
    </p>
  } @else if (!zonesWithTables.length) {
    <p class="cmb-muted">Add at least two tables to a zone to combine them.</p>
  } @else {
    @for (zone of zonesWithTables; track zone.id) {
      <section class="cmb-zone" [attr.data-testid]="'zone-' + zone.id">
        <header class="cmb-zone-head">
          <h3 class="cmb-zone-title">{{ zone.zone_name }}</h3>
          <span class="cmb-count">{{ combinationsIn(zone.id).length }}</span>
          <button type="button" class="cmb-add" (click)="startAdd(zone.id)">
            <i class="bx bx-plus" aria-hidden="true"></i> Add combination
          </button>
        </header>

        @if (combinationsIn(zone.id).length) {
          <ul class="cmb-list">
            @for (c of combinationsIn(zone.id); track c.combination_id) {
              <li class="cmb-row" [class.cmb-row--editing]="editingId === c.combination_id">
                <span class="cmb-tables">{{ label(c.table_ids) }}</span>
                <span class="cmb-party">{{ c.min_party }}–{{ c.max_party }} guests</span>
                <span class="cmb-name">{{ c.name }}</span>
                <span class="cmb-actions">
                  @if (confirmingId === c.combination_id) {
                    <span class="cmb-confirm">Remove {{ label(c.table_ids) }}?</span>
                    <button
                      type="button"
                      class="cmb-link cmb-link--danger"
                      [disabled]="saving"
                      (click)="remove(c)"
                    >
                      Remove
                    </button>
                    <button type="button" class="cmb-link" (click)="confirmingId = null">
                      Keep
                    </button>
                  } @else {
                    <button type="button" class="cmb-link" (click)="edit(c)">Edit</button>
                    <button type="button" class="cmb-link cmb-link--danger" (click)="askRemove(c)">
                      Remove
                    </button>
                  }
                </span>
              </li>
            }
          </ul>
        } @else {
          <p class="cmb-muted cmb-pad">No combinations in this zone yet.</p>
        }

        @if (suggestions(zone.id).length) {
          <div class="cmb-suggest" data-testid="suggestions">
            <span class="cmb-suggest-label">Side by side on the floor plan:</span>
            @for (pair of suggestions(zone.id); track pair.join('|')) {
              <button type="button" class="cmb-chip" (click)="startAdd(zone.id, pair)">
                {{ label(pair) }} <i class="bx bx-plus" aria-hidden="true"></i>
              </button>
            }
          </div>
        }

        @if (formOpen && form.value.zone === zone.id) {
          <form class="cmb-form" [formGroup]="form" (ngSubmit)="save()" data-testid="form">
            <span class="cmb-form-title">{{
              editingId ? 'Edit combination' : 'New combination'
            }}</span>

            <span class="cmb-field-label"
              >Tables <span class="cmb-muted">pick 2 to {{ maxTables }}</span></span
            >
            <div class="cmb-pick" role="group" aria-label="Tables in this combination">
              @for (t of zoneTables(zone.id); track t.table_id) {
                <button
                  type="button"
                  class="cmb-pick-btn"
                  [class.cmb-pick-btn--on]="isSelected(t.table_id)"
                  [attr.aria-pressed]="isSelected(t.table_id)"
                  [disabled]="!isSelected(t.table_id) && selected.length >= maxTables"
                  (click)="toggleTable(t.table_id)"
                >
                  @if (isSelected(t.table_id)) {
                    <i class="bx bx-check" aria-hidden="true"></i>
                  }
                  {{ t.table_name }} <span class="cmb-seats">{{ t.number_of_seats }}</span>
                </button>
              }
            </div>

            @if (selected.length >= 2) {
              <p class="cmb-muted">
                {{ label(selected) }} have {{ seatsOf(selected) }} seats. Pushed together, a few are
                usually lost where the tables meet.
              </p>
            }

            <div class="cmb-inline">
              <label
                >Smallest party
                <input
                  type="number"
                  class="cmb-input"
                  formControlName="minParty"
                  min="1"
                  (input)="partyChanged()"
              /></label>
              <label
                >Largest party
                <input
                  type="number"
                  class="cmb-input"
                  formControlName="maxParty"
                  min="1"
                  (input)="partyChanged()"
              /></label>
              <label
                >Name <span class="cmb-muted">optional</span>
                <input
                  type="text"
                  class="cmb-input cmb-input--name"
                  formControlName="name"
                  maxlength="40"
                  [placeholder]="label(selected) || 'e.g. Window booth'"
              /></label>
            </div>

            @if (formError) {
              <p class="cmb-error" role="alert">{{ formError }}</p>
            }

            <div class="cmb-buttons">
              <button type="submit" class="cmb-save" [disabled]="saving || !!formError">
                {{ editingId ? 'Save combination' : 'Add combination' }}
              </button>
              <button type="button" class="cmb-link" (click)="cancel()">Cancel</button>
            </div>
          </form>
        }
      </section>
    }
  }
</div>
